export type VisibilityOption = {
  iconClassName: string;
  value: 'public' | 'secret' | 'private';
  label: string;
  description?: string;
  currentLabel: string;
  projectSettingsDescription: string;
};

export const visibilityOptions: VisibilityOption[] = [
  {
    iconClassName: 'i-heroicons:globe-asia-australia',
    value: 'public',
    label: 'Public',
    description: undefined,
    currentLabel: 'This project is public',
    projectSettingsDescription: 'Everyone can view',
  },
  {
    iconClassName: 'i-heroicons:eye-slash',
    value: 'secret',
    label: 'Secret',
    description: 'accessible by URL',
    currentLabel: 'This project is secret',
    projectSettingsDescription: 'Accessible via shared URL',
  },
  {
    iconClassName: 'i-heroicons:lock-closed',
    value: 'private',
    label: 'Private',
    description: undefined,
    currentLabel: 'This project is private',
    projectSettingsDescription: 'Only owner can access',
  },
];
